import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useProduct } from '@thd-nucleus/data-sources';
import styles from './global-custom-configurator.module.scss';

const GlobalCustomConfigurator = (props) => {
  const { itemId } = props;
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('global-custom-configurator.ready'); }, []);

  const { data, loading, error } = useProduct({ itemId, domains: ['info'] });
  if (!data || loading || (error && !data)) {
    return null;
  }

  const { globalCustomConfigurator } = data.product.info || {};
  if (!globalCustomConfigurator) return null;

  return (
    <div className={styles['global-custom-configurator__container']} data-component="custom options">
      <a
        className={styles['global-custom-configurator__container-link']}
        href={globalCustomConfigurator.customExperienceUrl}
        data-target="configurator button submission"
      >
        <div className={styles['global-custom-configurator__info-box']}>
          <img
            className={styles['global-custom-configurator__icon']}
            src="http://assets.homedepot-static.com/images/v1/order-sample.svg"
            alt="sample icon"
          />
          <div className={styles['global-custom-configurator__info-text']}>
            <div className={styles['global-custom-configurator__custom-size']}>
              {globalCustomConfigurator.customTitle}
            </div>
            <div className={styles['global-custom-configurator__cta-messaging']}>
              {globalCustomConfigurator.customDescription}
            </div>
          </div>
        </div>
        <div className={styles['global-custom-configurator__button-wrapper']}>
          {/* eslint-disable-next-line max-len */}
          <div className={`bttn-outline bttn-outline--primary bttn--inline ${styles['global-custom-configurator__cta-button']}`}>
            <span className="bttn__content">
              {globalCustomConfigurator.customButtonText}
            </span>
          </div>
        </div>
      </a>
    </div>
  );
};

GlobalCustomConfigurator.displayName = 'GlobalCustomConfigurator';

GlobalCustomConfigurator.propTypes = {
  itemId: PropTypes.string,
};

GlobalCustomConfigurator.defaultProps = {
  itemId: null
};

export { GlobalCustomConfigurator };
